export { default } from './PromotionalMaterialsService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/promotionalMaterials/services/PromotionalMaterialsService/index.js